
import React from "react";

export default function GalleryPending({
  user
}) {

  return (

    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 24,
        background:
          "radial-gradient(circle at top left,#60a5fa,#7c3aed,#111827)"
      }}
    >

      <div
        style={{
          width: "100%",
          maxWidth: 700,
          background:
            "rgba(255,255,255,.97)",
          borderRadius: 30,
          padding: 35,
          boxShadow:
            "0 25px 70px rgba(0,0,0,.25)",
          textAlign: "center"
        }}
      >

        <div
          style={{
            fontSize: 70,
            marginBottom: 15
          }}
        >
          ⏳
        </div>

        <h1
          style={{
            marginTop: 0,
            marginBottom: 10
          }}
        >
          Application Under Review
        </h1>

        <p
          style={{
            color: "#6b7280",
            marginBottom: 30,
            lineHeight: 1.7
          }}
        >
          Thank you for applying to
          become a PITICS Gallery
          Partner.
          <br />
          Our team is currently
          reviewing your application.
        </p>

        {user?.photoURL && (

          <img
            src={
              user.photoURL
            }
            alt=""
            style={{
              width: 110,
              height: 110,
              borderRadius:
                "50%",
              objectFit:
                "cover",
              border:
                "4px solid #e5e7eb",
              marginBottom: 15
            }}
          />

        )}

        <h3
          style={{
            marginBottom: 5
          }}
        >
          {
            user?.displayName ||
            "Gallery Partner"
          }
        </h3>

        <p
          style={{
            color: "#6b7280",
            marginBottom: 25
          }}
        >
          {
            user?.email || ""
          }
        </p>

        <div
          style={{
            textAlign: "left",
            background:
              "#f8fafc",
            padding: 20,
            borderRadius: 18,
            marginBottom: 25
          }}
        >

          <h3
            style={{
              marginTop: 0
            }}
          >
            After Approval You Can
          </h3>

          <p>
            ✅ Upload drawings
          </p>

          <p>
            ✅ Upload coloring pages
          </p>

          <p>
            ✅ Upload worksheets
          </p>

          <p>
            ✅ Upload educational charts
          </p>

          <p>
            ✅ Upload learning activities
          </p>

          <p>
            ✅ Manage your uploaded content
          </p>

        

        </div>
		
		<div
  style={{
    background: "#EFF6FF",
    border: "1px solid #BFDBFE",
    color: "#1E40AF",
    padding: 16,
    borderRadius: 14,
    marginBottom: 20
  }}
>
  Approval usually requires
  manual review by the PITICS
  team. Once approved, you
  will automatically gain
  access to the Gallery
  Dashboard.
</div>

        <div
          style={{
            background:
              "#FEF3C7",
            color:
              "#92400E",
            padding: 16,
            borderRadius: 14,
            fontWeight: 600
          }}
        >
          Your application status:
          Pending Approval
        </div>
<div
  style={{
    marginTop: 15
  }}
>
  <button
    onClick={() =>
      window.location.reload()
    }
    style={{
      border: "none",
      padding: "10px 18px",
      borderRadius: 10,
      cursor: "pointer",
      background: "#2563eb",
      color: "#fff",
      fontWeight: 600
    }}
  >
    Check Status Again
  </button>
</div>
      </div>

    </div>

  );

}

